
    import '/home/ec2-user/Youlify-Design/components/timeline/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["timeline-demo-basic","timeline-demo-color","timeline-demo-pending","timeline-demo-alternate","timeline-demo-custom","timeline-demo-right","timeline-demo-label","timeline-demo-wireframe","timeline-demo-component-token"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/timeline/index.en-US.md?type=demo')
};